import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconVimeoStyle0 = gravityIconIndividualCss;

const GravityIconVimeo = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '7eafe87c6c2882b47018362632c256ec90e4a763', color: this.color, size: this.size }, h("svg", { key: '8eb0eb306ab821ed41258dda5bf3252307c5563a', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '1ba9200252c78d01552804f1164336601dd6aa49', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18.145 7.672c-.064 1.396-1.036 3.306-2.914 5.732-1.951 2.525-3.594 3.78-4.936 3.78-.839 0-1.501-.76-2.12-2.297-.38-1.413-.768-2.826-1.147-4.239-.433-1.545-.884-2.296-1.378-2.296a4.25 4.25 0 0 0-1.122.672l-.68-.883 2.093-1.864a4.636 4.636 0 0 1 2.12-1.29c1.112-.105 1.766.654 2.049 2.288.282 1.634.45 2.844.582 3.285.318 1.457.671 2.19 1.06 2.19.388 0 .75-.477 1.342-1.422.487-.64.828-1.378.998-2.163.088-.821-.23-1.228-.963-1.228a2.755 2.755 0 0 0-1.05.23c.677-2.302 2.007-3.417 3.991-3.347 1.466 0 2.155.99 2.075 2.852Z", fill: "currentColor" }))));
    }
};
GravityIconVimeo.style = GravityIconVimeoStyle0;

export { GravityIconVimeo as gravity_icon_vimeo };

//# sourceMappingURL=gravity-icon-vimeo.entry.js.map